<template>
  <div class="panel-page" :class="{light: light}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Panel',
  props: {
    light: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less" scoped>
.panel-page {
  background: #f5f6fa;
  border-radius: 8px;
  &.light {
    background: #ffffff;
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.06);
    border-radius: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Panel/index.vue